import React from 'react';
import { Header, Footer } from '../components/layout';
import { HeroSection } from '../features/landing/HeroSection';
import { FeatureGrid } from '../features/landing/FeatureGrid';
import { TransparencySection } from '../features/landing/TransparencySection';

export const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-white dark:bg-slate-950 transition-colors">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <FeatureGrid />
        <TransparencySection />
      </main>
      <Footer />
    </div>
  );
};
